import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark, Play } from "lucide-react";
import { Thumb } from "./VideoCard";
import { kidApi } from "../lib/api";
import { catById } from "../lib/constants";

export const FavoritesShelf = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { kidApi.get("/kid/favorites").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section data-testid="favorites-shelf" className="mb-6 sm:mb-10">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-display text-xl sm:text-2xl font-bold flex items-center gap-2"><Bookmark size={20} fill="#FFD23F" /> My Favorites</h2>
        <Link to="/kid/shorts?list=favorites" data-testid="favorites-play-all" className="zn-chip bg-[#FFD23F]"><Play size={14} fill="#1B1A2E" /> Play all</Link>
      </div>
      <div className="flex gap-3 overflow-x-auto no-scrollbar snap-x scroll-px-4 -mx-4 px-4 sm:mx-0 sm:px-0 pb-2">
        {items.map((v) => (
          <Link key={v.id} to={`/kid/shorts?list=favorites&start=${v.id}`} data-testid={`favorite-${v.id}`}
            className="relative shrink-0 snap-start w-28 sm:w-36 aspect-[3/4] rounded-2xl border-[3px] border-[#1B1A2E] overflow-hidden zn-dots shadow-[3px_3px_0_0_#1B1A2E] zn-lift" style={{ backgroundColor: catById(v.category).color }}>
            {v.thumb && <Thumb id={v.id} title={v.title} />}
            <span className="absolute inset-x-0 bottom-0 p-2 bg-gradient-to-t from-black/75 to-transparent text-white text-xs font-semibold leading-tight line-clamp-2">{v.title}</span>
          </Link>
        ))}
      </div>
    </section>
  );
};
